/**
 * Where the API actually answers.
 *
 * Two entries, and the second one is the point: production has a name and a
 * plan and no deployment behind it. A docs page that lists one base URL leaves
 * a reader to assume it is the permanent one; a page that lists two without
 * saying which is live invites somebody to point a production system at a
 * hostname that does not resolve. So availability is a field, not a footnote,
 * and the page renders it.
 */
export interface Environment {
  /** Short Persian name, as it appears in the table. */
  labelFa: string
  baseUrl: string
  /** What a caller can do here today. */
  availabilityFa: string
  live: boolean
}

export const ENVIRONMENTS: readonly [Environment, Environment] = [
  {
    labelFa: 'محیط آزمون (Stage)',
    baseUrl: 'https://api-platform-stage.office.lan',
    availabilityFa: 'محیط فعلی. اعتبارنامه‌ها و فراخوانی‌های شما همین‌جا انجام می‌شود.',
    live: true,
  },
  {
    labelFa: 'محیط عملیاتی (Production)',
    baseUrl: 'https://api.mobinsandogh.ir',
    availabilityFa: 'هنوز راه‌اندازی نشده است. این نشانی برای برنامه‌ریزی آمده و در حال حاضر پاسخ نمی‌دهد.',
    live: false,
  },
]


export function apiEnvironmentForHost(host: string): Environment {
  return host === 'capi.mobinsandogh.ir' ? ENVIRONMENTS[1] : ENVIRONMENTS[0]
}

export function currentApiEnvironment(): Environment {
  return apiEnvironmentForHost(window.location.hostname)
}
